import { useEffect, useRef, useState } from "react";

// Plays a sequence of videos as a full-bleed background, crossfading between them.
// The first clip loads eagerly for a fast hero paint; the rest are primed only
// after the first clip starts playing, so they never slow the initial load.
export function HeroVideoBg({ sources = [], poster }) {
  const [active, setActive] = useState(0);
  const [primed, setPrimed] = useState(false);
  const vids = useRef([]);

  useEffect(() => {
    const el = vids.current[active];
    if (el) {
      el.currentTime = 0;
      el.play().catch(() => {});
    }
  }, [active]);

  // Once the first clip is playing, preload the remaining clips in the background.
  const handlePlaying = (i) => {
    if (i === 0 && !primed) {
      setPrimed(true);
      vids.current.slice(1).forEach((v) => v && v.load());
    }
  };

  const next = () => setActive((a) => (a + 1) % sources.length);

  return (
    <div className="absolute inset-0">
      {sources.map((src, i) => (
        <video
          key={src}
          ref={(el) => (vids.current[i] = el)}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ease-in-out ${
            i === active ? "opacity-100" : "opacity-0"
          }`}
          autoPlay={i === 0}
          muted
          playsInline
          preload={i === 0 || primed ? "auto" : "none"}
          poster={poster}
          onPlaying={() => handlePlaying(i)}
          onEnded={next}
          data-testid={`hero-video-${i}`}
        >
          <source src={src} type="video/mp4" />
        </video>
      ))}
    </div>
  );
}

export default HeroVideoBg;
